export const SET_USERS = 'Users/set';
export const SET_USERS_UPDATED = 'Users/UpdateStatus/set';
